import styled from "styled-components";

const PartnerStyleWrapper = styled.div`
  
  padding-bottom: 110px;

  .section_title {
    text-align: center;
    .subtitle {
      color: #ffffff;
    }

    margin-bottom: 45px;
  }

  .slick-slider {
    
    .slick-list {
      position: relative;

      &::before {
        width: 50px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;


        content: "";
        z-index: 1;
      }
      &::after {
        width: 50px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        content: "";
        z-index: 1;
      }
    }
  }

  .slick__slider__item {
    img {
      
      cursor: pointer;
      transition: all 0.4s;
      
    }
    &:hover {
      img {
        opacity: 0.7;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    padding-bottom: 80px;
  }
`;

export default PartnerStyleWrapper;